<p-toast /><p-confirmDialog />
<section class="w-full md:p-3">
  @if (loadError()) {
    <p class="mb-3 text-red-500 text-center">No se pudo cargar el listado. Probá de nuevo más tarde.</p>
  }

  <app-content-card title="Congregación">
    <app-aviso-activar-push />
    <div class="border-1 surface-border border-round overflow-hidden bg-white min-w-0">
      <div class="flex flex-column md:flex-row md:align-items-center md:justify-content-between gap-3 px-3 py-3 md:py-2 border-bottom-1 surface-border bg-white">
        <div class="w-full md:flex-1 flex md:justify-content-start min-w-0">
          @if (showNameSearch()) {
            <p-iconfield id="congregacion-name-search" class="w-full md:w-auto" iconPosition="left">
              <p-inputicon [styleClass]="esperandoBusqueda() ? 'pi pi-spinner pi-spin' : 'pi pi-search'" />
              <input
                pInputText
                type="text"
                class="w-full md:w-12rem p-inputtext-sm"
                placeholder="Buscar por nombre..."
                [ngModel]="search()"
                (ngModelChange)="onSearchInput($event)"
                [attr.aria-busy]="esperandoBusqueda()"
                autocomplete="off"
              />
            </p-iconfield>
          }
        </div>

        <div class="w-full md:flex-1 text-center min-w-0">
          <p class="m-0 mb-1 font-semibold text-sm text-color">{{ filtroCopy().titulo }}</p>
          <p class="m-0 text-sm text-color-secondary line-height-3">{{ filtroCopy().detalle }}</p>
        </div>

        <div class="w-full md:flex-1 flex md:justify-content-end min-w-0">
          <select
            id="congregacion-filtro"
            aria-label="Filtrar por"
            class="w-full md:w-12rem p-2 border-1 border-round surface-border bg-white text-color cursor-pointer text-sm"
            [ngModel]="filtro()"
            (ngModelChange)="onFiltroChange($event)"
          >
            @for (opt of filtroOptions; track opt.id) {
              <option [ngValue]="opt.id">{{ opt.label }}</option>
            }
          </select>
        </div>
      </div>

      <app-person-table
        [rows]="rows()"
        [columns]="columns()"
        [loading]="loading()"
        [paginator]="true"
        [rowsPerPage]="pageSize"
        [lazy]="true"
        [totalRecords]="totalRecords()"
        [first]="first()"
        [filtro]="filtro()"
        [yoId]="yoId()"
        [isAdmin]="isAdmin()"
        (pageChange)="onTablePageChange($event)"
        (menuAction)="onMenuAction($event)"
      />
    </div>
  </app-content-card>
</section>

<p-dialog
  [visible]="avisoLiderVisible()"
  (visibleChange)="onAvisoLiderVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '32rem' }"
  header="Esta persona es líder"
>
  <p class="m-0 text-color">
    <span class="font-semibold">{{ nombreAEliminar() }}</span>
    es líder y {{ textoDiscipulos() }}.
  </p>
  <p class="mt-3 mb-0 text-sm text-color-secondary">
    ¿Transferimos sus discípulos a otro líder? Si no, al confirmar la eliminación quedan sin líder
    y pasan al muelle. {{ nombreAEliminar() }} se mueve a la papelera recién cuando confirmás.
  </p>

  <div class="flex flex-wrap justify-content-end gap-2 pt-4">
    <p-button
      type="button"
      label="Cancelar"
      severity="secondary"
      [text]="true"
      (onClick)="cancelarEliminarLider()"
    />
    <p-button
      type="button"
      label="No, al muelle"
      severity="secondary"
      [outlined]="true"
      (onClick)="dejarSinLider()"
    />
    <p-button type="button" label="Sí, transferir" icon="pi pi-users" (onClick)="abrirElegirLider()" />
  </div>
</p-dialog>

<p-dialog
  [visible]="elegirLiderVisible()"
  (visibleChange)="onElegirLiderVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '32rem' }"
  header="Transferir discípulos"
>
  <p class="m-0 mb-3 text-sm text-color-secondary">
    Elegí el líder que va a recibir a los discípulos de {{ nombreAEliminar() }}. La eliminación se
    confirma en el paso siguiente.
  </p>

  <label class="text-sm font-semibold text-color" for="congregacion-lider-destino">Nuevo líder</label>
  <p-select
    inputId="congregacion-lider-destino"
    [options]="lideresOpciones()"
    optionLabel="label"
    optionValue="value"
    placeholder="Elegí un líder"
    [filter]="lideresOpciones().length > 6"
    filterPlaceholder="Buscar líder"
    appendTo="body"
    styleClass="w-full mt-1"
    [loading]="cargandoLideres()"
    [ngModel]="liderDestino()"
    (ngModelChange)="liderDestino.set($event)"
    [disabled]="cargandoLideres()"
  />

  @if (!cargandoLideres() && lideresOpciones().length === 0) {
    <p class="mt-2 mb-0 text-sm text-color-secondary">
      No hay otros líderes para recibir a los discípulos. Podés volver y mandarlos al muelle.
    </p>
  }

  <div class="flex justify-content-end gap-2 pt-4">
    <p-button
      type="button"
      label="Volver"
      severity="secondary"
      [outlined]="true"
      (onClick)="volverAlAviso()"
    />
    <p-button
      type="button"
      label="Continuar"
      icon="pi pi-check"
      [disabled]="!liderDestino()"
      (onClick)="continuarConLider()"
    />
  </div>
</p-dialog>
